import Model, { attr, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import BookingModel from 'uplisting-frontend/models/booking';
import BookingRequestModel from 'uplisting-frontend/models/booking-request';
import {
  InboxMessageChannel,
  type IInboxMessageSchema,
} from 'uplisting-frontend/models/schemas';

export default class InboxMessageModel
  extends Model
  implements IInboxMessageSchema
{
  @attr('string') externalId!: string;
  @attr('string') content!: string;
  @attr('string') channel!: InboxMessageChannel;
  @attr('boolean') inbound!: boolean;
  @attr('string') from!: string;
  @attr('boolean') unread!: boolean;
  @attr('boolean') starred!: boolean;
  @attr('boolean') archived!: boolean;
  @attr('string') status!: string;
  @attr('date') lastMessageAt!: Date;
  @attr('string') lastMessageType!: string;
  @attr('number') lastMessageId!: number;
  @attr('string') propertyName!: string;
  @attr('string') guestName!: string;
  @attr('string') guestProfilePicture!: string;

  @hasMany('booking', { async: false, inverse: null })
  bookings!: BookingModel[];

  @hasMany('booking-request', { async: false, inverse: null })
  bookingRequests!: BookingRequestModel[];

  @cached
  get isBookingDotCom(): boolean {
    return this.channel === InboxMessageChannel.bookingDotCom;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'inbox-message': InboxMessageModel;
  }
}
